import type { ReactNode } from 'react';
import { Breadcrumb, type BreadcrumbProperties } from '../breadcrumb';
import { Flex } from '../flex';
import { Title } from '../typography';
import { useCreateBreadcrumbItems } from './hooks';
import styles from './page-header.module.css';

type P = {
  breadcrumb?: BreadcrumbProperties;
  className?: string;
  extra?: ReactNode;
  title?: ReactNode;
};

const PageHeader = ({ breadcrumb, className, extra, title }: P) => {
  const titleNode = typeof title === 'string' ? <Title ellipsis={{ tooltip: title }}>{title}</Title> : title;
  const breadcrumbItems = useCreateBreadcrumbItems({ breadcrumb });

  return (
    <div className={className}>
      {breadcrumbItems?.length ? <Breadcrumb items={breadcrumbItems} /> : null}
      {Boolean(titleNode) || Boolean(extra) ? (
        <Flex align="center" gap="ms" justify="space-between">
          {titleNode ? (
            <Flex align="center" className={styles.title} flex={1}>
              {titleNode}
            </Flex>
          ) : null}
          {extra ? (
            <Flex align="center" gap="xs" justify="center">
              {extra}
            </Flex>
          ) : null}
        </Flex>
      ) : null}
    </div>
  );
};

export default PageHeader;
